import { ChangeDetectionStrategy, Component, signal, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

interface Story {
  id: string;
  title: string;
  category: string;
  categoryLabel: string;
  coverImage: string;
  duration: string;
  isPrompt: boolean;
  authorName: string;
  authorAvatar: string;
  views: number;
  hearts: number;
  familyGroup: string;
  date: string;
}

interface FilterCategory {
  value: string;
  label: string;
}

@Component({
  selector: 'app-stories-list',
  templateUrl: './stories-list.html',
  styleUrl: './stories-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, FormsModule],
})
export class StoriesList {
  readonly activeFilter = signal<string>('all');
  readonly viewMode = signal<'grid' | 'list'>('grid');
  readonly searchQuery = signal<string>('');

  readonly filterCategories: FilterCategory[] = [
    { value: 'all',                   label: 'All Stories' },
    { value: 'career-work',           label: 'Career & work' },
    { value: 'childhood',             label: 'Childhood stories' },
    { value: 'dreams-aspirations',    label: 'Dreams & Aspirations' },
    { value: 'proudest-moments',      label: 'Proudest Moments' },
    { value: 'milestones',            label: 'Milestones' },
    { value: 'family-traditions',     label: 'Family Traditions' },
    { value: 'grandparents-heritage', label: 'Grandparents & Heritage' },
    { value: 'love-relationship',     label: 'Love & Relationship' },
  ];

  readonly allStories: Story[] = [
    { id: '1', title: 'My First Day of School',      category: 'childhood',             categoryLabel: 'Childhood',           coverImage: 'images/stories/stories-post-1.png', duration: '2:22',  isPrompt: true,  authorName: 'Patricia J', authorAvatar: 'images/stories/fm-st-user-01.png', views: 105, hearts: 80, familyGroup: 'Johnsons Family', date: '6 days ago' },
    { id: '2', title: 'Meeting Your Grandmother',    category: 'love-relationship',     categoryLabel: 'Love & Relationship', coverImage: 'images/stories/stories-post-2.png', duration: '12:22', isPrompt: true,  authorName: 'Patricia J', authorAvatar: 'images/stories/fm-st-user-01.png', views: 105, hearts: 80, familyGroup: 'Johnsons Family', date: '6 days ago' },
    { id: '3', title: 'Working at the Factory',      category: 'career-work',           categoryLabel: 'Career & Work',       coverImage: 'images/stories/stories-post-3.png', duration: '8:22',  isPrompt: true,  authorName: 'Patricia J', authorAvatar: 'images/stories/fm-st-user-01.png', views: 105, hearts: 80, familyGroup: 'Johnsons Family', date: '6 days ago' },
    { id: '4', title: 'The War Years',               category: 'milestones',            categoryLabel: 'Major Life Moment',   coverImage: 'images/stories/stories-post-4.png', duration: '2:22',  isPrompt: false, authorName: 'Patricia J', authorAvatar: 'images/stories/fm-st-user-01.png', views: 105, hearts: 80, familyGroup: 'Johnsons Family', date: '6 days ago' },
    { id: '5', title: 'Raising Our Children',        category: 'family-traditions',     categoryLabel: 'Childhood',           coverImage: 'images/stories/stories-post-5.png', duration: '2:22',  isPrompt: false, authorName: 'Patricia J', authorAvatar: 'images/stories/fm-st-user-01.png', views: 105, hearts: 80, familyGroup: 'Johnsons Family', date: '6 days ago' },
    { id: '6', title: 'Our Wedding Day',             category: 'love-relationship',     categoryLabel: 'Love & Relationship', coverImage: 'images/stories/stories-post-6.png', duration: '12:22', isPrompt: true,  authorName: 'Patricia J', authorAvatar: 'images/stories/fm-st-user-01.png', views: 105, hearts: 80, familyGroup: 'Johnsons Family', date: '6 days ago' },
    { id: '7', title: 'Learning to Drive',           category: 'milestones',            categoryLabel: 'Learning to Drive',   coverImage: 'images/stories/stories-post-7.png', duration: '8:22',  isPrompt: true,  authorName: 'Patricia J', authorAvatar: 'images/stories/fm-st-user-01.png', views: 105, hearts: 80, familyGroup: 'Johnsons Family', date: '6 days ago' },
    { id: '8', title: "Grandma's Apple Pie Recipe",  category: 'grandparents-heritage', categoryLabel: 'Childhood',           coverImage: 'images/stories/stories-post-8.png', duration: '2:22',  isPrompt: true,  authorName: 'Patricia J', authorAvatar: 'images/stories/fm-st-user-01.png', views: 105, hearts: 80, familyGroup: 'Johnsons Family', date: '6 days ago' },
  ];

  readonly filteredStories = computed(() => {
    const filter = this.activeFilter();
    const query = this.searchQuery().toLowerCase();
    return this.allStories.filter(s => {
      const matchFilter = filter === 'all' || s.category === filter;
      const matchSearch = !query || s.title.toLowerCase().includes(query) || s.authorName.toLowerCase().includes(query);
      return matchFilter && matchSearch;
    });
  });

  setFilter(value: string): void { this.activeFilter.set(value); }
  setViewMode(mode: 'grid' | 'list'): void { this.viewMode.set(mode); }
  onSearch(value: string): void { this.searchQuery.set(value); }
}
